import createReducer from '../createReducer'
import { UPDATE_VIEWPORT } from './constants'
import isServer from 'shared/isServer'

const initialState = {
  deviceWidth: null,
  width: isServer() ? null : window.innerWidth,
}

export default createReducer(initialState, {
  name: 'viewport',
  [UPDATE_VIEWPORT]: (state, action) => {
    return { ...state, ...action.payload }
  },
})
